export function moveTowards(current: number, target: number, maxDelta: number) {
	if (current < target) return Math.min(current + maxDelta, target);
	if (current > target) return Math.max(current - maxDelta, target);
	return current;
}


